import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { gettext, translationPropType } from '@eb/i18n';

import { GREYS_JSON } from '@eb/eds-color';
import { Illustration } from '@eb/eds-illustration';

import { IMAGE_STYLE_FIXED } from '../constants';
import { getRandomFallbackImage } from '../utils';

import ActionWrapper from './ActionWrapper';

export default class Image extends PureComponent {
    static propTypes = {
        onClick: PropTypes.func,
        linkUrl: PropTypes.string,
        imageUrl: PropTypes.string,
        imageAlt: PropTypes.oneOfType([PropTypes.string, translationPropType]),
        imageStyle: PropTypes.string,
        hasNoTabIndex: PropTypes.bool,
        placeholderBgColor: PropTypes.string,
        isTargetBlank: PropTypes.bool,
        isNoFollow: PropTypes.bool,
        isConsumer: PropTypes.bool,
        isLazyImage: PropTypes.bool,
    };

    static defaultProps = {
        placeholderBgColor: GREYS_JSON['grey-200'],
    };

    render() {
        const {
            onClick,
            linkUrl,
            imageUrl,
            imageAlt = gettext('Event image'),
            imageStyle,
            hasNoTabIndex,
            placeholderBgColor,
            isTargetBlank,
            isNoFollow,
            isConsumer,
            isLazyImage,
        } = this.props;
        const imageClassNames = classNames('eds-media-card-content__image', {
            'eds-max-img': imageStyle === IMAGE_STYLE_FIXED,
        });
        const imageWrapperClassNames = classNames(
            'eds-media-card-content__image-wrapper',
            {
                'eds-media-card-content__image-wrapper--with-width': !linkUrl,
                'eds-media-card-content__image-wrapper--sharp-corners': isConsumer,
            },
        );

        const imageContentClassNames = classNames(
            'eds-media-card-content__image-content',
            {
                'eds-media-card-content__image-content--sharp-corners': isConsumer,
            },
        );

        const placeholderStyles = {
            backgroundColor: placeholderBgColor,
        };

        let image = null;

        if (isLazyImage || !imageUrl) {
            image = (
                <div className="eds-media-card-content__image--svg">
                    <Illustration
                        type={getRandomFallbackImage(imageAlt)}
                        width="100%"
                        height="100%"
                    />
                </div>
            );
        } else if (imageUrl) {
            image = (
                <img
                    className={imageClassNames}
                    src={imageUrl}
                    alt={imageAlt}
                />
            );
        }

        return (
            <ActionWrapper
                onClick={onClick}
                linkUrl={linkUrl}
                linkAlt={imageAlt}
                hasNoTabIndex={hasNoTabIndex}
                isTargetBlank={isTargetBlank}
                isNoFollow={isNoFollow}
            >
                <div className={imageWrapperClassNames}>
                    <div className={imageContentClassNames}>
                        <div
                            className="eds-media-card-content__image-placeholder"
                            style={placeholderStyles}
                        />
                        {image}
                    </div>
                </div>
            </ActionWrapper>
        );
    }
}
